import { Link, withRouter } from "react-router-dom";
import React from 'react'
import { IoIosArrowBack } from "react-icons/io";

const BackBtn = ({ url, history }) => {
    return (
        <div className="overallbck">
            {url ? <Link to={url} className="icons btn-icon text-green mr-4 d-flex">
                <IoIosArrowBack /> Go Back
            </Link> : <span onClick={() => history.goBack()} className="icons pointer btn-icon text-green mr-4 d-flex">
                <IoIosArrowBack /> Go Back
            </span>}
        </div>
    )
}

export default withRouter(BackBtn);